import axios from "axios";

export const aseoService = {
  // ============= FUNCIÓN BASE =============
  async apiCall(endpoint, token) {
    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // ============= MÉTODO PRINCIPAL UNIFICADO =============

  // Obtener todos los datos de aseo (rentas, inmueble/comercio, tipo renta, deudas, petro)
  async getAseo(
    idrentas,
    token,
    conexion,
    fechaSistema,
    espiritu,
    anioactu,
    factorCambio,
  ) {
    // 1. Obtener datos de la renta
    const rentaEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${idrentas}&nomtab=rentasinmobiliarias&nomid=idrentas`;
    const rentaResponse = await this.apiCall(rentaEndpoint, token);

    if (rentaResponse.status !== 200 || !rentaResponse.data?.idrentas) {
      throw new Error("No se encontró la renta");
    }

    const rentaData = rentaResponse.data;
    let entidadData = null;
    let credito = 0;

    // 2. Obtener datos según el tipo de tabla (inmueble o comercio)
    if (rentaData.tipotabla === 0 && rentaData.idinmueble) {
      // Es inmueble
      const inmuebleEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${rentaData.idinmueble}&nomtab=inmueble&nomid=idinmueble`;
      const inmuebleResponse = await this.apiCall(inmuebleEndpoint, token);
      if (
        inmuebleResponse.status === 200 &&
        inmuebleResponse.data?.idinmueble > 0
      ) {
        entidadData = inmuebleResponse.data;
        credito = inmuebleResponse.data.credito || 0;
      }
    } else if (rentaData.tipotabla === 1 && rentaData.idinmueble) {
      // Es comercio
      const comercioEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${rentaData.idinmueble}&nomtab=comercio&nomid=idcomercio`;
      const comercioResponse = await this.apiCall(comercioEndpoint, token);
      if (
        comercioResponse.status === 200 &&
        comercioResponse.data?.idcomercio > 0
      ) {
        entidadData = comercioResponse.data;
        credito = comercioResponse.data.credito || 0;
      }
    }

    // 3. Obtener datos del tipo de renta
    let tipoRentaData = null;
    if (rentaData.idtiporenta) {
      const tipoRentaEndpoint = `${conexion}/api/consulta/modeli?campos=*&id=${rentaData.idtiporenta}&nomtab=tiporentas&nomid=idtiporentas`;
      const tipoRentaResponse = await this.apiCall(tipoRentaEndpoint, token);
      if (
        tipoRentaResponse.status === 200 &&
        tipoRentaResponse.data?.idtiporentas > 0
      ) {
        tipoRentaData = tipoRentaResponse.data;
      }
    }

    // 4. Obtener deudas de aseo
    let deudasEndpoint;
    const tabla = "aseo";
    if (espiritu === 0) {
      deudasEndpoint = `${conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}`;
    } else {
      deudasEndpoint = `${conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}`;
    }
    const deudasResponse = await this.apiCall(deudasEndpoint, token);

    // 5. Obtener valor del petro
    let valorPetro = 0;
    try {
      const petroEndpoint = `${conexion}/api/efiscal/valorpetro`;
      const petroResponse = await this.apiCall(petroEndpoint, token);
      if (petroResponse.status === 200 && petroResponse.data) {
        valorPetro = petroResponse.data.valor || petroResponse.data;
      }
    } catch (error) {
      console.error("Error al obtener valor del petro:", error);
      // No interrumpimos el flujo si falla el petro
    }

    // 6. Retornar todos los datos mapeados
    return {
      status: 200,
      mappedData: {
        renta: this.mapRentasData(rentaData),
        entidad: entidadData,
        tipoRenta: this.mapTipoRentasData(tipoRentaData),
        deudas: this.mapDeudasAseo(
          deudasResponse.data || [],
          fechaSistema,
          anioactu,
          factorCambio,
        ),
        credito: credito,
        valorPetro: valorPetro,
      },
    };
  },

  // ============= MÉTODOS INDIVIDUALES (si los necesitas) =============

  // Seleccionar valor del petro (individual)
  async seleccionarValorPetro(token, conexion) {
    try {
      const endpoint = `${conexion}/api/efiscal/valorpetro`;
      const response = await this.apiCall(endpoint, token);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener deudas de aseo (individual)
  async getDeudaAseo(
    idrentas,
    fechaSistema,
    espiritu,
    anioactu,
    factorCambio,
    token,
    conexion,
  ) {
    let endpoint;
    const tabla = "aseo";

    if (espiritu === 0) {
      endpoint = `${conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}`;
    } else {
      endpoint = `${conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla}`;
    }

    const response = await this.apiCall(endpoint, token);

    if (response.status === 200) {
      return {
        ...response,
        mappedData: this.mapDeudasAseo(
          response.data,
          fechaSistema,
          anioactu,
          factorCambio,
        ),
      };
    }
    return response;
  },

  // ============= MAPEADORES =============

  // Mapear deudas de aseo
  mapDeudasAseo(data, fechaSistema, anioactu, factorCambio = 1) {
    if (!data || data.length === 0) return { deu: [], his: [] };

    const deu = [];
    const his = [];
    const mesactu = (new Date(fechaSistema).getMonth() + 1)
      .toString()
      .padStart(2, "0");

    data.forEach((item) => {
      const deudaBase = {
        anio: item.anio,
        mes: item.mes?.replace(/'/g, ""),
        monto: item.mondeu,
        intereses: (item.intmoradeu || 0) * factorCambio,
        multa: (item.multa || 0) * factorCambio,
        recargo: (item.recargodeu || 0) * factorCambio,
      };

      if (item.fechapago === null) {
        // Verificar si es deuda vigente
        if (parseInt(item.anio) < parseInt(anioactu)) {
          deu.push(deudaBase);
        } else if (
          parseInt(item.anio) === parseInt(anioactu) &&
          parseInt(item.nmes) < parseInt(mesactu)
        ) {
          deu.push(deudaBase);
        }
      } else {
        his.push({
          ...deudaBase,
          descuento: item.mondescue,
          recibo: item.numreci,
          fechapago: item.fechapago,
        });
      }
    });

    return { deu, his };
  },

  // Mapear datos de rentas
  mapRentasData(data) {
    if (!data) return null;
    return {
      ...data,
    };
  },

  // Mapear datos de tipo de rentas
  mapTipoRentasData(data) {
    if (!data) return null;
    return {
      idtiporentas: data.idtiporentas,
      descripcion: data.descripcion,
      alicuota: data.alicuota,
    };
  },
};
